var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5499 5.11094C21.8311 5.39224 21.9891 5.7737 21.9891 6.17144C21.9891 6.56919 21.8311 6.95065 21.5499 7.23194L10.3069 18.4749C10.1584 18.6236 9.98196 18.7414 9.78781 18.8219C9.59367 18.9023 9.38558 18.9437 9.17543 18.9437C8.96529 18.9437 8.7572 18.9023 8.56305 18.8219C8.36891 18.7414 8.19251 18.6236 8.04393 18.4749L2.45793 12.8899C2.31467 12.7516 2.20039 12.5861 2.12178 12.4031C2.04317 12.22 2.00179 12.0232 2.00006 11.824C1.99833 11.6249 2.03628 11.4274 2.1117 11.243C2.18712 11.0587 2.2985 10.8912 2.43934 10.7504C2.58018 10.6095 2.74766 10.4981 2.932 10.4227C3.11635 10.3473 3.31387 10.3093 3.51303 10.3111C3.7122 10.3128 3.90903 10.3542 4.09204 10.4328C4.27505 10.5114 4.44056 10.6257 4.57893 10.7689L9.17493 15.3649L19.4279 5.11094C19.5672 4.97155 19.7326 4.86098 19.9147 4.78554C20.0967 4.7101 20.2919 4.67126 20.4889 4.67126C20.686 4.67126 20.8811 4.7101 21.0632 4.78554C21.2452 4.86098 21.4106 4.97155 21.5499 5.11094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon_check.7495328f3125c027ff475e89f7eb232e.svg";
export { ForwardRef as ReactComponent };